import { render, staticRenderFns } from "./AdvertisingLocalTree.vue?vue&type=template&id=023183dc&scoped=true"
import script from "./AdvertisingLocalTree.vue?vue&type=script&lang=js"
export * from "./AdvertisingLocalTree.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingLocalTree.vue?vue&type=style&index=0&id=023183dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023183dc",
  null
  
)

export default component.exports